<template>
  <div>
    <span v-if="isRegular">
      Regular
    </span>
    <span v-else-if="isGroupMessage">
      <el-tooltip effect="light" placement="left" content="Group message" v-if="isGroupMessage">
        <span>
          <i class="fas fa-users mr-1"></i> Group
        </span>
      </el-tooltip>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    row: Object,
  },

  computed: {
    /**
     * @return {boolean}
     */
    isRegular() {
      return ! this.isGroupMessage && ! this.isCampaignMessage;
    },

    /**
     * @return {Boolean}
     */
    isGroupMessage() {
      return ! _.isNull(_.get(this.row, 'bulk_message_id'));
    },
  },
};
</script>

<style scoped>

</style>
